import { Route, Routes } from 'react-router-dom'
import { aliasMapAuth, getComponentAuth } from './AuthRouter'
import NothingHere from '../pages/error/NothingHere'
import ReceiptIdentification from '../pages/ReceiptIdentification'
import ReceiptResult from '../pages/ReceiptResult'

export default function PublicRouter() {
    return (
        <div className="contenedor-full vh-100">
            <Routes>
                {Object.entries(aliasMapAuth).map(([alias, path]) => (
                    <Route key={alias} path={alias} element={getComponentAuth(path)} />
                ))}
                <Route path="/nothinghere" element={<NothingHere />} />
                <Route path="*" element={<NothingHere />} />
                <Route path="/identificacion" element={<ReceiptIdentification />} />
                <Route path="/receipt/result/:id/:status" element={<ReceiptResult />} />
            </Routes>
        </div>
    )
}